import t from 'react-translate'
import { css } from '@emotion/react';

import { seafoam } from 'athena/styles/colors';
import { danger, success, yellow } from 'styles/global_defaults/colors';
import { CsatDistribution } from 'redux/schemas/app/analytics';
import { extractTextFromHTML } from 'shared/utils';

import ScaleBar from './scale-bar';


type CsatScaleProps = {
  distribution: CsatDistribution;
  question: string;
};

const styles = css`
  min-height: 200px;
  flex: 1;
`;

const CsatScale = ({ distribution, question }: CsatScaleProps) => (
  <div css={styles} className='bg-white p-4'>
    <div className='text-large-regular bold mb-4'>
      {extractTextFromHTML(question)}
    </div>
    <ScaleBar
      scores={[
        { score: distribution['1'].percentage, color: `${danger}66`, text: t.COURSE_ANALYTICS.NPS_CSAT_SURVEY.CSAT_SCORE_RATING(distribution['1'].count, '1') },
        { score: distribution['2'].percentage, color: `${danger}33`, text: t.COURSE_ANALYTICS.NPS_CSAT_SURVEY.CSAT_SCORE_RATING(distribution['2'].count, '2') },
        { score: distribution['3'].percentage, color: `${yellow}33`, text: t.COURSE_ANALYTICS.NPS_CSAT_SURVEY.CSAT_SCORE_RATING(distribution['3'].count, '3') },
        { score: distribution['4'].percentage, color: `${seafoam}33`, text: t.COURSE_ANALYTICS.NPS_CSAT_SURVEY.CSAT_SCORE_RATING(distribution['4'].count, '4') },
        { score: distribution['5'].percentage, color: `${success}66`, text: t.COURSE_ANALYTICS.NPS_CSAT_SURVEY.CSAT_SCORE_RATING(distribution['5'].count, '5') },
      ]}
    />
  </div>
);

export default CsatScale;
